"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkoutApiClient = void 0;
const axios_1 = __importDefault(require("axios"));
const react_uuid_1 = __importDefault(require("react-uuid"));
const config_1 = require("../../utils/helpers/config");
exports.checkoutApiClient = axios_1.default.create({
    baseURL: config_1.envConfig.checkoutApiUrl,
    headers: {
        client_id: config_1.envConfig.checkoutApiKey,
        'X-Correlation-ID': (0, react_uuid_1.default)(),
    },
});
